export enum EnvironmentType {
  LOCAL = 'local',
  DEV = 'dev',
  TEST = 'test',
  PROD = 'prod',
}
